import {
  isFullscreenActive,
  requestDocumentFullscreen,
  shouldOfferMobileFullscreen,
} from "./Fullscreen";
import { createButton, createElement } from "./dom";

export class MobileFullscreenPrompt {
  public readonly element = createElement("section", "mobile-fullscreen-prompt hidden");
  private readonly confirmButton: HTMLButtonElement;
  private readonly status = createElement("p", "mobile-fullscreen-status");
  private dismissed = false;
  private mobile = false;

  public constructor() {
    this.element.setAttribute("role", "dialog");
    this.element.setAttribute("aria-modal", "true");
    this.element.setAttribute("aria-labelledby", "mobile-fullscreen-title");
    const panel = createElement("div", "mobile-fullscreen-panel");
    const eyebrow = createElement("div", "eyebrow", "НАСТРОЙКА МОБИЛЬНОГО ТЕРМИНАЛА");
    const title = createElement("h2", undefined, "ПОЛНЫЙ ЭКРАН");
    title.id = "mobile-fullscreen-title";
    const description = createElement(
      "p",
      "mobile-fullscreen-copy",
      "Для точного управления и максимального обзора откройте игру на весь экран.",
    );
    this.status.setAttribute("role", "status");
    this.confirmButton = createButton("ПЕРЕЙТИ В ПОЛНЫЙ ЭКРАН", () => {
      void this.enterFullscreen();
    });
    const laterButton = createButton("НЕ СЕЙЧАС", () => {
      this.dismissed = true;
      this.hide();
    });
    const actions = createElement("div", "mobile-fullscreen-actions");
    actions.append(this.confirmButton, laterButton);
    panel.append(eyebrow, title, description, actions, this.status);
    this.element.append(panel);
    document.addEventListener("fullscreenchange", this.onFullscreenChange);
    document.addEventListener("webkitfullscreenchange", this.onFullscreenChange);
  }

  public sync(isMobile: boolean): void {
    this.mobile = isMobile;
    const shouldShow = shouldOfferMobileFullscreen(
      isMobile,
      isFullscreenActive(),
      this.dismissed,
    );
    this.element.classList.toggle("hidden", !shouldShow);
    if (shouldShow) queueMicrotask(() => this.confirmButton.focus());
  }

  public dispose(): void {
    document.removeEventListener("fullscreenchange", this.onFullscreenChange);
    document.removeEventListener("webkitfullscreenchange", this.onFullscreenChange);
  }

  private async enterFullscreen(): Promise<void> {
    this.status.textContent = "";
    const result = await requestDocumentFullscreen();
    if (result === "entered") {
      this.dismissed = true;
      this.hide();
      return;
    }
    this.status.textContent =
      result === "unsupported"
        ? "Браузер не поддерживает полноэкранный режим для этой страницы."
        : "Не удалось открыть полный экран. Разрешите его в настройках браузера.";
  }

  private hide(): void {
    this.element.classList.add("hidden");
  }

  private readonly onFullscreenChange = (): void => {
    if (isFullscreenActive()) {
      this.dismissed = true;
      this.hide();
    } else {
      this.sync(this.mobile);
    }
  };
}
